export enum OverviewViewEnum {
  ALL_ORDERS = 'ALL_ORDERS',
  OPTION_ORDERS = 'OPTION_ORDERS',
}

export type OverviewViewEnumType = keyof typeof OverviewViewEnum;
